<template>
  <div class="get-started-card" @click="navigateTo" :style="{ backgroundImage: `url(${carouselImg})` }">
    <div class="card-overlay"></div>
    <div class="card-content">
      <div class="card-text">
        <h4>Get Started with Calid</h4>
        <p>Set up your first sensor and start monitoring your environment</p>
      </div>
      <div class="card-arrow">
        <i class="fas fa-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import carouselImg from "@/assets/img/carousel-1.jpg";

const router = useRouter();

const navigateTo = () => {
  router.push("/account/get-started");
};
</script>

<style scoped>
.get-started-card {
  position: relative;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  min-height: 140px;
  background-size: cover;
  background-position: center;
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.4) 100%);
  transition: background 0.3s ease;
}

.get-started-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
}

.get-started-card:hover .card-overlay {
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 100%);
}

.get-started-card:hover .card-arrow {
  transform: translateX(4px);
  background: rgba(255, 255, 255, 0.25);
}

.card-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 1.5rem;
  height: 100%;
  min-height: 140px;
}

.card-text {
  flex: 1;
}

.card-text h4 {
  font-size: 1.25rem;
  font-weight: 600;
  color: white;
  margin: 0 0 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.card-text p {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.card-arrow {
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.card-arrow i {
  color: white;
  font-size: 1.125rem;
}
</style>